import React, { useState, useEffect } from "react";
import { Container, KWhText, KWText, Switch } from "./GraphSwitch.styles";

const GraphSwitch = ({ callback, color }) => {
  const [isKW, setIsKW] = useState(false);

  useEffect(() => {
    callback(isKW);
  }, [isKW]);

  return (
    <Container color={color} onClick={() => setIsKW(!isKW)}>
      <KWhText isKW={isKW} color={color}>
        Energy
      </KWhText>
      <KWText isKW={isKW} color={color}>
        Power
      </KWText>
      <Switch isKW={isKW} />
    </Container>
  );
};

GraphSwitch.defaultProps = {
  callback: (isKW) =>
    console.log(
      `The value of isKW is ${isKW}, this is the default callback, you need to pass a callback function as a prop to retrieve the value`
    ),
  color: "#FF8524",
};

export default GraphSwitch;



// WEBPACK FOOTER //
// ./resources/assets/js/app/SchoolProfileView/components/GraphSwitch/GraphSwitch.js